import CourseCardsList from './CourseCardsList';
import { CourseCardsListProps, CourseCardsListValueProps } from './types';

export type { CourseCardsListProps, CourseCardsListValueProps };
export default CourseCardsList;
